import { makeVar } from '@apollo/client';

export const defaultLeasingCommission = {
  commissionId: 0,
  commissionCode: '',
  commissionName: '',
  commissionPercent: null,
  commissionValue: null,
  assignToRoleId: null,
  isReadOnly: false,
  calcTypeId: '',
  isSubsidy: false,
  isCommission: false
};

export const leasingCommissionModalVar = makeVar({ open: false, item: defaultLeasingCommission });
